class DoclrToggleSwitchDirective {
    constructor() {
        'ngInject';
        this.restrict = 'A';
        this.templateUrl = '/partials/components/utils/doclr.toggle.switch.html';
        this.scope = {
            trueLabel: '@',
            falseLabel: '@'
        };
        this.require = 'ngModel';

    }

    controller($scope, $state, ConstantExpressionParser, $parse) {
        $scope.state = $state;
        $scope.constantExpressionParser = ConstantExpressionParser;
        $scope.$parse = $parse;
    }

    link(scope, element, attrs, ngModelCtrl) {

        var trueValue = scope.constantExpressionParser(scope.$parse, scope, 'ngTrueValue', attrs.ngTrueValue, true);
        var falseValue = scope.constantExpressionParser(scope.$parse, scope, 'ngFalseValue', attrs.ngFalseValue, false);
        scope.redGreen = 'redGreen' in attrs;
        scope.smallButton = 'smallButton' in attrs;

        ngModelCtrl.$formatters.push(function (modelValue) {
            return angular.equals(modelValue, trueValue);
        });

        ngModelCtrl.$parsers.push(function (viewValue) {
            return viewValue ? trueValue : falseValue;
        });

        ngModelCtrl.$viewChangeListeners.push(function () {
            scope.$eval(attrs.ngChange);
        });

        ngModelCtrl.$render = function () {
            scope.model = ngModelCtrl.$viewValue;
        };

        scope.setValue = function (value) {
            scope.model = value;
            ngModelCtrl.$setViewValue(scope.model);
        };
    }
}

(function () {
    'use strict';

    angular.module('doclr.components.util')
        .directive('doclrToggleSwitch', () => new DoclrToggleSwitchDirective());
})();